import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import ServiceSection from '../ServiceSection';

const DEFAULT_SERVICE_SLUG = 'architectural'; 

export default function Services() {
  const { hash } = useLocation();
  const { slug: slugParam } = useParams();
  const [slug, setSlug] = useState('');

  useEffect(() => {
    const fromParam = (slugParam || '').trim();
    const fromHash = (hash || '').replace('#', '').trim();
    const next = fromParam || fromHash || DEFAULT_SERVICE_SLUG;
    setSlug(next);
  }, [hash, slugParam]);

  if (!slug) return null;

  return (
    <main className="services-page">
      <ServiceSection slug={slug} />
    </main>
  );
}
